import axios from 'axios';
import useCurrentUser from '../hooks/useCurrentUser';
import { API_HOST } from '../constants/constants';
export const deletePatientNote = async (noteID) => {
  const apiURL = API_HOST + '/patient_notes/' + noteID;
  const { token, userID } = useCurrentUser();

  try {
    const { data } = await axios.delete(apiURL, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + token,
        'x-dqpn-user-id': userID,
      },
    });
    return data.data;
  } catch (error) {
    console.error(error);
  }
};
